import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/lib/useLenis";
import Scene from "@/three/Scene";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import CaseStudy from "@/pages/CaseStudy";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useLenis();
  return (
    <div className="App relative min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Scene />
        <Nav />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:slug" element={<CaseStudy />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="light" />
      </BrowserRouter>
    </div>
  );
}

export default App;
